import React, { useEffect, useState } from "react";
import { useDebounce } from "../../helpers/useDebounce";
import TableSearch from "../tables/table-search/TableSearch";

import s from "./WeaveInputWidget.module.scss";

export default function WeaveSearchWidget({
	text,
	delay = 1000,
	onChange = () => {},
}) {
	const [searchText, setSearchText] = useState(text);
	const debounceValue = useDebounce(searchText, delay);

	useEffect(() => {
		setSearchText(text);
	}, [text]);

	useEffect(() => {
		if (debounceValue !== text) {
			onChange(debounceValue);
		}
		// eslint-disable-next-line
	}, [debounceValue]);

	return (
		<div className={s.root}>
			<TableSearch
				searchText={searchText}
				setSearchText={setSearchText}
				className={s.search}
			/>
		</div>
	);
}
